import React, { useState } from 'react';
import Select from 'react-select';


export default function FormSelect({placeholder, options}) {
  const [selectedOption, setSelectedOption] = useState(null);

  return (
    <div className="select">
      <Select
        defaultValue={selectedOption}
        onChange={setSelectedOption}
        options={options}
        placeholder={placeholder}
      />
    </div>
  );
}